/** @jsx jsx */
import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { jsx } from "@emotion/react";
import { Link } from "gatsby";
import {
  AutoralAfetuosaBilingue,
  content,
  iconsBg6,
  desktop,
  mobile
} from "../assets/styles/PrimeiroPasso.style";

const PrimeiroPasso = () => {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
        setScrollPosition(window.scrollY/2);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
}, []);

  return (
    <section css={AutoralAfetuosaBilingue}>
      <Col css={mobile} className="img-container px-0" lg={5} md={12} sm={12}>
          <div
            css={iconsBg6}
            className="bg-image"
          ></div>
        </Col>
      <Container fluid>
        <Row className="title-content">
          <Col css={content} lg={7} md={12} sm={12}>
            <div className="col-content">
              <h2>Excelência acadêmica, bilinguismo e desenvolvimento pessoal</h2>
              <p>O Ensino Fundamental II da Kingdom marca a transição para uma etapa mais estruturada e exigente da formação escolar.</p>
              <p>Desde 2025, a Kingdom atua nos anos finais com uma proposta que aprofunda conteúdos, amplia responsabilidades e desenvolve autonomia intelectual, sempre com acompanhamento pedagógico constante.</p>
              <p>Crescemos com seu filho! A partir de 2025, a Kingdom começou a atuar no segmento de Educação Fundamental Anos finais.</p>
              <p style={{ textTransform: "uppercase", fontWeight: 600 }}>ORGANIZAÇÃO CURRICULAR E ROTINA ACADÊMICA</p>
              <p>- Horário Integral<br/>
                - Salas de aula-laboratório<br/>
                - 50% da grade curricular em inglês 
              </p>
            </div>
          </Col>
          <Col css={desktop} className="img-container px-0" lg={5} md={12} sm={12}>
          <div
            css={iconsBg6}
            className="bg-image"
          ></div>
        </Col>
        </Row>
      </Container>
    </section>
  );
};

export default PrimeiroPasso;
